import { useState, useEffect } from "react"
import { supabase } from "@/lib/supabase"
import type { Model } from "@/lib/types"
import ModelCard from "@/components/model-card"
import { useTranslation } from "react-i18next";

export default function ModelsList() {
  const [models, setModels] = useState<Model[]>([])
  const [loading, setLoading] = useState(true)
  const { t } = useTranslation("common"); // Add translation hook

  useEffect(() => {
    async function fetchModels() {
      try {
        const { data, error } = await supabase.from("available_models").select("*").order("order_number", { ascending: true })

        if (error) throw error

        if (data) setModels(data)
      } catch (error) {
        console.error("Error fetching models:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchModels()
  }, [])

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold mb-2">
          {t("modelsList.header.title")}
        </h1>
        <p className="text-muted-foreground font-medium mb-6">
          {t("modelsList.header.description")}
        </p>

        {loading ? (
          <div className="flex justify-center">
            <p>{t("modelsList.loading")}</p>
          </div>
        ) : models.length === 0 ? (
          <div className="bg-white p-6 rounded-lg shadow">
            <p>{t("modelsList.empty")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {models.map((model) => (
              <div key={model.id}>
                <ModelCard model={model} />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  )
}

